export function calculateInterest(rate: number, period: number): number{
    const percentInterest = (rate/period);
    return percentInterest;
}

export function calculateApyRate(rate: number): number{
    const period = 12;
    const interest = rate/100;
    const apy = (Math.pow(1 + (interest/period), period) - 1) * 100;
    return apy;
}

export function calculateAccruedInterest(principal: number, interestRate: number): number{
    return principal * calculateApyRate(interestRate) / 100;
}

export function calculateLowerBoundTier2ApyRate(principal: number, rate: number, tier2Rate: number): number{
    const totalPrincipal = principal + 100000;
    const tier1Interest = calculateAccruedInterest(principal, rate);
    const tier2Interest = calculateAccruedInterest(100000, tier2Rate);
    const combinedInterest = tier1Interest + tier2Interest;
    const tier2ApyLowerBoundRate = 12 * (Math.pow((totalPrincipal + combinedInterest)/totalPrincipal, 1/12) - 1) * 100;
    
    return tier2ApyLowerBoundRate;
}